// High-level regions shown in dropdowns
export default [
  { value: 'UKC', label: 'North East' },
  { value: 'UKD', label: 'North West' },
  { value: 'UKE', label: 'Yorkshire and the Humber' },
  { value: 'UKF', label: 'East Midlands' },
  { value: 'UKG', label: 'West Midlands' },
  { value: 'UKH', label: 'East of England' },
  { value: 'UKI', label: 'Greater London' },
  { value: 'UKJ', label: 'South East' },
  { value: 'UKK', label: 'South West' },
  { value: 'SCOTLAND', label: 'Scotland' },
  { value: 'WALES', label: 'Wales' },
  { value: 'NIR', label: 'Northern Ireland' },
  { value: 'Guernsey', label: 'Guernsey' },
  { value: 'Jersey', label: 'Jersey' },
  { value: 'Isle of Man', label: 'Isle of Man' },
]

// Maps PayPal/ApplePay UK county names to shipping zone codes
export const UK_COUNTY_MAP = {
  // UKC - North East
  cleveland: 'UKC',
  'county durham': 'UKC',
  northumberland: 'UKC',
  'tyne and wear': 'UKC',
  // UKD - North West
  cheshire: 'UKD',
  cumbria: 'UKD',
  'greater manchester': 'UKD',
  lancashire: 'UKD',
  merseyside: 'UKD',
  // UKE - Yorkshire and the Humber
  'east riding of yorkshire': 'UKE',
  'north east lincolnshire': 'UKE',
  'north humberside': 'UKE',
  'north yorkshire': 'UKE',
  'south humberside': 'UKE',
  'south yorkshire': 'UKE',
  'west yorkshire': 'UKE',
  // UKF - East Midlands
  derbyshire: 'UKF',
  leicestershire: 'UKF',
  lincolnshire: 'UKF',
  northamptonshire: 'UKF',
  nottinghamshire: 'UKF',
  rutland: 'UKF',
  // UKG - West Midlands
  herefordshire: 'UKG',
  shropshire: 'UKG',
  staffordshire: 'UKG',
  warwickshire: 'UKG',
  'west midlands': 'UKG',
  worcestershire: 'UKG',
  // UKH - East of England
  bedfordshire: 'UKH',
  cambridgeshire: 'UKH',
  essex: 'UKH',
  hertfordshire: 'UKH',
  norfolk: 'UKH',
  suffolk: 'UKH',
  // UKI - London
  london: 'UKI',
  // UKJ - South East
  berkshire: 'UKJ',
  buckinghamshire: 'UKJ',
  'east sussex': 'UKJ',
  hampshire: 'UKJ',
  'isle of wight': 'UKJ',
  kent: 'UKJ',
  middlesex: 'UKJ',
  oxfordshire: 'UKJ',
  surrey: 'UKJ',
  sussex: 'UKJ',
  'west sussex': 'UKJ',
  // UKK - South West
  avon: 'UKK',
  bristol: 'UKK',
  cornwall: 'UKK',
  devon: 'UKK',
  dorset: 'UKK',
  gloucestershire: 'UKK',
  'isles of scilly': 'UKK',
  somerset: 'UKK',
  wiltshire: 'UKK',
  // Scotland
  scotland: 'SCOTLAND',
  'aberdeen city': 'SCOTLAND',
  aberdeenshire: 'SCOTLAND',
  angus: 'SCOTLAND',
  argyll: 'SCOTLAND',
  'argyll and bute': 'SCOTLAND',
  ayrshire: 'SCOTLAND',
  banffshire: 'SCOTLAND',
  berwickshire: 'SCOTLAND',
  borders: 'SCOTLAND',
  caithness: 'SCOTLAND',
  central: 'SCOTLAND',
  clackmannanshire: 'SCOTLAND',
  'dumfries and galloway': 'SCOTLAND',
  dumfriesshire: 'SCOTLAND',
  dunbartonshire: 'SCOTLAND',
  'dundee city': 'SCOTLAND',
  'east ayrshire': 'SCOTLAND',
  'east dunbartonshire': 'SCOTLAND',
  'east lothian': 'SCOTLAND',
  'east renfrewshire': 'SCOTLAND',
  'edinburgh city': 'SCOTLAND',
  falkirk: 'SCOTLAND',
  fife: 'SCOTLAND',
  'glasgow city': 'SCOTLAND',
  grampian: 'SCOTLAND',
  highland: 'SCOTLAND',
  inverclyde: 'SCOTLAND',
  'inverness-shire': 'SCOTLAND',
  'isle of lewis': 'SCOTLAND',
  'isle of skye': 'SCOTLAND',
  kincardineshire: 'SCOTLAND',
  'kinross-shire': 'SCOTLAND',
  kirkcudbrightshire: 'SCOTLAND',
  lanarkshire: 'SCOTLAND',
  lothian: 'SCOTLAND',
  midlothian: 'SCOTLAND',
  moray: 'SCOTLAND',
  nairn: 'SCOTLAND',
  'north ayrshire': 'SCOTLAND',
  'north lanarkshire': 'SCOTLAND',
  'orkney islands': 'SCOTLAND',
  peeblesshire: 'SCOTLAND',
  'perth and kinross': 'SCOTLAND',
  perthshire: 'SCOTLAND',
  renfrewshire: 'SCOTLAND',
  'ross-shire': 'SCOTLAND',
  roxburghshire: 'SCOTLAND',
  selkirkshire: 'SCOTLAND',
  'shetland islands': 'SCOTLAND',
  'south ayrshire': 'SCOTLAND',
  'south lanarkshire': 'SCOTLAND',
  stirling: 'SCOTLAND',
  strathclyde: 'SCOTLAND',
  sutherland: 'SCOTLAND',
  tayside: 'SCOTLAND',
  'west dunbartonshire': 'SCOTLAND',
  'west lothian': 'SCOTLAND',
  'western isles': 'SCOTLAND',
  wigtownshire: 'SCOTLAND',
  // Wales
  wales: 'WALES',
  'blaenau gwent': 'WALES',
  bridgend: 'WALES',
  caerphilly: 'WALES',
  cardiff: 'WALES',
  carmarthenshire: 'WALES',
  ceredigion: 'WALES',
  clwyd: 'WALES',
  conwy: 'WALES',
  denbighshire: 'WALES',
  dyfed: 'WALES',
  flintshire: 'WALES',
  gwent: 'WALES',
  gwynedd: 'WALES',
  'isle of anglesey': 'WALES',
  'merthyr tydfil': 'WALES',
  'mid glamorgan': 'WALES',
  monmouthshire: 'WALES',
  'neath port talbot': 'WALES',
  newport: 'WALES',
  pembrokeshire: 'WALES',
  powys: 'WALES',
  'rhondda cynon taf': 'WALES',
  'south glamorgan': 'WALES',
  swansea: 'WALES',
  torfaen: 'WALES',
  'vale of glamorgan': 'WALES',
  'west glamorgan': 'WALES',
  wrexham: 'WALES',
  // Northern Ireland
  'northern ireland': 'NIR',
  'belfast city': 'NIR',
  'county antrim': 'NIR',
  'county armagh': 'NIR',
  'county down': 'NIR',
  'county fermanagh': 'NIR',
  'county londonderry': 'NIR',
  'county tyrone': 'NIR',
}
